import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'
import DoNotDisturbIcon from '@mui/icons-material/DoNotDisturb'
import EventRepeatIcon from '@mui/icons-material/EventRepeat'
import CloudSyncIcon from '@mui/icons-material/CloudSync'
import HighlightOffIcon from '@mui/icons-material/HighlightOff'
import SyncProblemIcon from '@mui/icons-material/SyncProblem'
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff'
import LockIcon from '@mui/icons-material/Lock'

import {useState} from 'react'
import {
    useGetYoutubeUploadStatusQuery,
    useRetryYoutubeUploadMutation,
} from 'store/slices/api/dancesApi'

const useYoutubeUploadStatus = (videoType) => {
    const [expandedId, setExpanded] = useState()

    const handleChange = (panelId) => (event, isExpanded) => {
        setExpanded(isExpanded ? panelId : false)
    }

    const {data: youtubeUploadStatus, isFetching} =
        useGetYoutubeUploadStatusQuery()
    const [retryYoutubeUpload, {isLoading: isRetrying}] =
        useRetryYoutubeUploadMutation()

    const headers = [
        '_id',
        'nameHeb',
        'nameEng',
        'youtubeId',
        'youtubeStatus',
        'youtubeError',
    ]

    const statusColors = {
        available: '#6BA292',
        restricted: '#F57373',
        uploading: '#7FB8F1',
        failed: '#F98C8C',
        retry: '#F9C86A',
        outdated: '#BDBDBD',
        unlisted: '#6BA292',
        private: '#6BA292',
    }

    const data = youtubeUploadStatus?.[videoType]
    const statusKeys = Object.keys(
        youtubeUploadStatus?.[videoType]?.counts || {}
    )

    const iconsMap = {
        available: (
            <CheckCircleOutlineIcon style={{color: statusColors.available}} />
        ),
        restricted: (
            <DoNotDisturbIcon style={{color: statusColors.restricted}} />
        ),
        outdated: <EventRepeatIcon style={{color: statusColors.outdated}} />,
        uploading: <CloudSyncIcon style={{color: statusColors.uploading}} />,
        failed: <HighlightOffIcon style={{color: statusColors.failed}} />,
        retry: <SyncProblemIcon style={{color: statusColors.retry}} />,
        unlisted: <VisibilityOffIcon style={{color: statusColors.unlisted}} />,
        private: <LockIcon style={{color: statusColors.private}} />,
    }

    const hideExpand = statusKeys.length === 1 && statusKeys[0] === 'available'

    const retryUpload = (danceId) => {
        retryYoutubeUpload({danceId, videoType})
    }

    return {
        headers,
        data,
        statusKeys,
        iconsMap,
        hideExpand,
        expandedId,
        handleChange,
        youtubeUploadStatus,
        retryUpload,
        isLoading: isFetching,
        isRetrying,
    }
}

export default useYoutubeUploadStatus
